import styled from "styled-components";


export const StyledHeadline = styled.p`
  margin: 0;
  font-size:12px;
  font-weight: bold;
  color: ${props => props.theme.color};
`;